/* eslint-disable import/prefer-default-export */
import { Platform } from '@/enums';
import isEmpty from 'lodash/isEmpty';

/**
 * @description 和 WebView 进行通信的方法
 *
 * @typedef {Object} WebViewOptions
 * @property {string} func 定义的函数名（前端通过该函数向 WebView 传递数据）
 * @property {any} data 传递给 WebView 的数据
 * @property {Record<string, (...arg: any[]) => any>} callbackObj 一个对象，里面是 Webview 定义的回调函数（前端通过该函数接受 WebView 的数据）
 *
 * @param {number} platform 平台类型（3：ios，4：Android）
 * @param {WebViewOptions} options
 */
export function webviewPostMessage(platform, { func = '', data = {}, callbackObj = {} }) {
    try {
        // 注册 callback
        if (!isEmpty(callbackObj)) {
            for (const key in callbackObj) {
                if (Object.hasOwnProperty.call(callbackObj, key)) {
                    window[key] = res => {
                        callbackObj[key](res);
                        // 执行后清空
                        window[key] = null;
                    };
                }
            }
        }

        switch (platform) {
            case Platform.WebView:
                window[func](JSON.stringify(data));
                break;
            case Platform.Android:
                {
                    const callbackKey = Object.keys(callbackObj)[0] || '';
                    window.logoffJsBridge[func](JSON.stringify(data), callbackKey);
                }
                break;
            // case other platforms
            default:
                break;
        }
    } catch (error) {
        console.log(error);
    }
}
